import React, { useRef } from 'react';
import '../App.css';

// 🔹 Importar imágenes de la Biblioteca CRA (reemplaza por las tuyas)
import Cra01 from '../img/Cra01.jpeg';
import Cra02 from '../img/Cra02.jpeg';
import Cra03 from '../img/Cra03.jpeg';
import Cra04 from '../img/papelucho.jpeg';
import Cra05 from '../img/el caleuche.jpeg';
import Cra06 from '../img/la pincoya.jpeg';
import Cra07 from '../img/el copihue.jpeg';


const BibliotecaCraComponent = () => {
  const scrollRef = useRef(null);

  const bibliotecaCraData = [
    {
      id: 1,
      date: 'Biblioteca CRA  Actividad',
      title: '',
      description: '',
      imageUrl: Cra01,
      type: 'image',
    },
    {
      id: 2,
      date: 'Biblioteca CRA  Actividad',
      title: '',
      description: '',
      imageUrl: Cra02,
      type: 'image',
    },
    {
      id: 3,
      date: 'Biblioteca CRA  Actividad',
      title: '',
      description: '',
      imageUrl: Cra03,
      type: 'image',
    },
    
    {
      id: 5,
      date: 'Conoce Cuentos Mitos y Leyendas Chilenas', 
      title: 'Papelucho',
      description: '',
      imageUrl: Cra04,
      type: 'image',
    },
    {
      id: 4,
      date: 'Conoce Cuentos Mitos y Leyendas Chilenas', 
      title: 'El Caleuche',
      description: '',
      imageUrl: Cra05,
      type: 'image',
    },
    {
      id: 6,
      date: 'Conoce Cuentos Mitos y Leyendas Chilenas',  
      title: 'La Pincoya',
      description: '',
      imageUrl: Cra06,
      type: 'image',
    },
    {
      id: 7,
      date: 'Conoce Cuentos Mitos y Leyendas Chilenas',
      title: 'El Copihue',
      description: '',
      imageUrl: Cra07,
      type: 'image',
    },
  ];

  const openFileInNewTab = (fileUrl) => {
    window.open(fileUrl, '_blank');
  };

  return (
    <div id="biblioteca-cra-component" className="events-component">
      <h2>Biblioteca CRA (Doble clic para ampliar)</h2>

      <div className="carousel-container no-arrows">
        <div className="event-cards-container large-cards" ref={scrollRef}>
          {bibliotecaCraData.map((item) => (
            <div key={item.id} className="event-card large-card cra-card">
              <div className="event-date cra-date">{item.date}</div>

              <div className="event-details cra-details">
                
                <h1>{item.title}</h1>

                <p className="event-description">{item.description}</p>

                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="cra-image large-image"
                  onDoubleClick={() => openFileInNewTab(item.imageUrl)}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BibliotecaCraComponent;
